/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Corporate_FinanceInputs */

const en_corporate_finance = /** @type {(inputs: Corporate_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance`)
};

const nl_corporate_finance = /** @type {(inputs: Corporate_FinanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finance`)
};

/**
* | output |
* | --- |
* | "Finance" |
*
* @param {Corporate_FinanceInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const corporate_finance = /** @type {((inputs?: Corporate_FinanceInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Corporate_FinanceInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_corporate_finance(inputs)
	return en_corporate_finance(inputs)
});